export default "__VITE_ASSET__CsqEc5r5__"